/* eslint-disable react/react-in-jsx-scope */
import { useTranslation } from "react-i18next";
import { Box, Typography, TableContainer, Paper, useTheme } from "@mui/material";
import type { IRoadLayoutConfig, ILightingClassConfig } from "types";
import CriteriaTable from "./Criteria";
import getStyles from "./styles";
import { useMemo } from "react";

export const RoadState: React.FC<{
  s_state: string;
  e_state_left: string;
  e_state_right: string;
  roadLayoutConfig: IRoadLayoutConfig;
  lightingClassConfig: ILightingClassConfig;
}> = ({ s_state, e_state_left, e_state_right, roadLayoutConfig, lightingClassConfig }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme).RoadState, [theme]);

  return (
    <Box sx={styles.container}>
      <Typography variant="h2" sx={styles.title} id="target-reach-info-title">
        {t("Target reach information")}
      </Typography>
      <TableContainer component={Paper} sx={styles.card}>
        <CriteriaTable
          roadLayoutConfig={roadLayoutConfig}
          lightingClassConfig={lightingClassConfig}
          s_state={s_state}
          e_state_left={e_state_left}
          e_state_right={e_state_right}
          sx={styles.table}
        />
      </TableContainer>
    </Box>
  );
};
